// removed by extract-text-webpack-plugin
module.exports = {"CrtPrint":"_1tSnf27XDsanaDNfWl_oB5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Certificate/styles.css
// module id = 677
// module chunks = 0